import { render, staticRenderFns } from "./SelectableOption.vue?vue&type=template&id=127eafae&scoped=true&"
import script from "./SelectableOption.vue?vue&type=script&lang=js&"
export * from "./SelectableOption.vue?vue&type=script&lang=js&"
import style0 from "./SelectableOption.vue?vue&type=style&index=0&id=127eafae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127eafae",
  null
  
)

export default component.exports